import React from 'react';

const Task = ({task}) => {
    return (
        <div>
            {/* <h5>{task?.title1[0]?.text}</h5> */}
            <p><span className="fw-bold fs-6 me-2">{task?.title1[0]?.text}</span> {task?.description1[0]?.text}.</p>
        </div>
    );
};

export default Task;